import { getDetailSection } from "@/api/Section.api";
const mixin = {
  store: ["detailsSection"],
  data() {
    return {
      loadingDetailSection: false,
      keyDetailSection: 0,
    };
  },
  methods: {
    async handleGetDetailSection() {
      this.keyDetailSection++;
      let params = {
        keyword: "",
        sub_key: this.$route.params.chapter,
        id: this.$route.params.section,
      };
      this.loadingDetailSection = true;
      await getDetailSection(params)
        .then(({result}) => {
          this.detailsSection = result;
          this.loadingDetailSection = false;
        })
        .catch((error) => {
          this.loadingDetailSection = false;
          console.log(error);
        });
    },
    async resetList() {
      await this.handleGetDetailSection();
    },
  },
};

export default mixin;
